import React, { memo } from "react"
import { Stack, Typography, Badge } from "@mui/material"
import PlaceIcon from "@mui/icons-material/Place"

export const BillingAddressCell = memo(({ billingAddress }) => {
  const fullName = `${billingAddress.first_name} ${billingAddress.last_name}`

  return (
    <Stack direction="row" spacing={2} alignItems="center">
      <Badge
        variant="dot"
        color="secondary"
        overlap="circular"
        invisible={!billingAddress.is_default}
      >
        <PlaceIcon />
      </Badge>
      <Stack>
        <Typography variant="h6">{billingAddress.company}</Typography>
        <Typography variant="h6" fontWeight="400">
          {fullName}
        </Typography>
      </Stack>
    </Stack>
  )
})
